<template>
  <div id="performance-and-endurance" class="performance-and-endurance" data-sidebar="2">
    <!-- 能效引擎 -->
    <div class="efficiency-engine" data-position="0" data-name="场景能效引擎">
      <div class="efficiency-engine-container">
        <!-- 背景图片 -->
        <PlusImage class="efficiency-engine-background" :src="performanceAndEnduranceWallpaper" />
        <div class="efficiency-engine-content" v-animate>
          <p class="efficiency-engine-content-title ffm500">场景能效2.0</p>
          <p v-if="!isPC" class="efficiency-engine-content-subtitle ffm600">性能与续航，稳稳拿捏</p>
          <div v-else class="efficiency-engine-content-subtitle ffm600">
            <p>性能与续航，</p>
            <p>稳稳拿捏</p>
          </div>
          <div v-if="isPC || isPad" class="efficiency-engine-content-description ffm400">
            <p>六大自研感知能效算法，</p>
            <p>配合高能效缓存架构与IO存储直通方案，</p>
            <p>无论视频通话、连续拍照，还是游戏场景，</p>
            <p>都能达到性能与续航的良好平衡。</p>
          </div>
          <div v-else-if="isMobile" class="efficiency-engine-content-description ffm400">
            <p>六大自研感知能效算法，配合高能效缓存架构与IO</p>
            <p>存储直通方案，无论视频通话、连续拍照，还是游戏</p>
            <p>场景，都能达到性能与续航的良好平衡。</p>
          </div>
        </div>
        <div class="efficiency-engine-data-container" v-animate>
          <div 
            v-for="(item, index) in efficiencyEngineData" 
            :key="index"
            class="efficiency-engine-data-item"
          >
            <p class="efficiency-engine-data-item-description ffm500">{{ item.unit }}</p>
            <p class="efficiency-engine-data-item-number ffm600">{{ item.number }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 续航科技 -->
     <div id="endurance-technology" class="endurance-technology">
      <div class="card-container">
        <!-- 微电精灵 -->
        <div class="micro-power-elf" v-animate data-position="1" data-name="微电精灵2.0">
          <div class="micro-power-elf-content-container">
            <p class="micro-power-elf-content-title ffm500">微电精灵2.0</p>
            <p class="micro-power-elf-content-subtitle ffm600">插上电，精彩继续</p>
            <div v-if="isPC" class="micro-power-elf-content-description ffm400">
              <p>游戏、办公时电量见底？别担心，</p>
              <p>进入「微电精灵」模式后，只要一插上电源，</p>
              <p>就能秒回你刚才的任务与状态！</p>
              <p>继续沉浸，无需等待。</p>
            </div>
            <div v-else-if="isMobile" class="micro-power-elf-content-description ffm400">
              <p>游戏、办公时电量见底？别担心，进入「微电</p>
              <p>精灵」模式后，只要一插上电源，就能秒回你</p>
              <p>刚才的任务与状态！继续沉浸，无需等待。</p>
            </div>
            <div v-else-if="isPad" class="micro-power-elf-content-description ffm400">
              <p>游戏、办公时电量见底？别担心，进入</p>
              <p>「微电精灵」模式后，只要一插上电</p>
              <p>源，就能秒回你刚才的任务与状态！继</p>
              <p>续沉浸，无需等待。</p>
            </div>
          </div>
          <div v-if="!isPC"  class="micro-power-elf-phone-container">
            <PlusImage class="micro-power-elf-phone-model" :src="PERFORMANCE_ENDURANCE.phoneModel1"></PlusImage>
            <PlusImage class="micro-power-elf-phone-wallpaper" :src="PERFORMANCE_ENDURANCE.phoneWallpaper"></PlusImage>
            <PlusImage class="micro-power-elf-phone-charger" :src="PERFORMANCE_ENDURANCE.phoneCharger1"></PlusImage>
          </div>
          <video v-else ref="microPowerElfVideo" class="micro-power-elf-phone-container" :src="VIDEO.microPowerElf" muted="true" preload="metadata"></video>
        </div>
        <div class="sm-card-container" data-position="2" data-name="直驱供电">
          <!-- 直驱供电 -->
          <div class="direct-drive-power-supply sm-card" v-animate>
            <div class="direct-drive-power-supply-container">
              <p class="direct-drive-power-supply-title ffm500">全局直驱供电2.0</p>
              <p class="direct-drive-power-supply-subtitle ffm600">玩的尽兴，充的安心</p>
              <div class="direct-drive-power-supply-description ffm400">
                <p>加入智能温控、智慧充电两大创新技术，不仅加速了边充边玩时的充电效率，还减少了发热，为您带来更加安全、快捷且舒适的使用体验。</p>
              </div>
            </div>
            <div class="direct-drive-power-supply-phone-container">
              <PlusImage class="direct-drive-power-supply-phone" :src="PERFORMANCE_ENDURANCE.phone"></PlusImage>
            </div>
          </div>
          <!-- 轻量化系统 -->
          <div class="lightweight-system sm-card" v-animate>
            <div class="lightweight-system-container">
              <p class="lightweight-system-title ffm500">系统轻量化3.0</p>
              <p class="lightweight-system-subtitle ffm600">超长待机</p>
              <div class="lightweight-system-description ffm400">
                <p>唤醒少一点，休眠快一点，后台负担轻一点。</p>
              </div>
            </div>
            <div class="lightweight-system-image-container">
              <PlusImage v-if="isPC" class="lightweight-system-image" :src="PERFORMANCE_ENDURANCE.cardBackground"></PlusImage>
              <PlusImage v-else class="lightweight-system-image" :src="PERFORMANCE_ENDURANCE.cardBackground2"></PlusImage>
              <div class="lightweight-system-image-text">
                <span class="lightweight-system-image-number ffm500">待机时长至多提升</span>
                <span class="lightweight-system-image-unit ffm600">7%↑</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { initExposureTrack } from "@/utils/track.js";
import PlusImage from "@/components/PlusImage.vue";
import { PERFORMANCE_ENDURANCE } from '@/config/image';
import VIDEO from '@/config/video';
export default {
  name: "PerformanceAndEndurance",
  components: {
    PlusImage
  },
  props: {},
  data() {
    return {
      PERFORMANCE_ENDURANCE,
      VIDEO,
      videoObserver: null,
      efficiencyEngineData: [
        { unit: "视频通话续航至多提升", number: "7%↑" },
        { unit: "连续刷短视频续航至多提升", number: "18%↑" },
        { unit: "游戏续航至多提升", number: "14%↑" }
      ]
    };
  },
  methods: {
    createMicroPowerElfVideoObserver(video) {
      let hasFullyLeft = false;
      let hasFullyEnteredOnce = false;
      let playPromise
      return new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const ratio = entry.intersectionRatio;
          
          if (entry.isIntersecting) {
            if (ratio >= 1.0) {
              hasFullyEnteredOnce = true;
              
              if (hasFullyLeft) {
                video.currentTime = 0;
                playPromise = video.play();
                hasFullyLeft = false;
              } else {
                playPromise = video.play();
              }
            }
            else if (ratio < 0.4 && hasFullyEnteredOnce) {
              if (playPromise !== undefined) {
                playPromise.finally(_ => {
                  video.pause();
                })
              }
            }
          } else {
            if (ratio === 0) {
              hasFullyLeft = true;
            }
            if (playPromise !== undefined) {
              playPromise.finally(_ => {
                video.pause();
              })
            }
          }
        });
      }, {
        threshold: [0, 0.4, 1.0] // 监听完全离开(0)、60%超出(0.4)和完全可见(1.0)
      });
    },

    initVideoObserver() {
      if (!this.isPC) return;
      
      this.$nextTick(() => {
        const video = this.$refs.microPowerElfVideo;
        if (!video) return;

        this.videoObserver = this.createMicroPowerElfVideoObserver(video);
        this.videoObserver.observe(video);
      });
    },
  },
  computed: {
    ...mapGetters(['isMobile', 'isPad', 'isPC']),
    performanceAndEnduranceWallpaper() {
      if (this.isPC) {
        return PERFORMANCE_ENDURANCE.wallpaperPC
      } else if (this.isMobile) {
        return PERFORMANCE_ENDURANCE.wallpaperPhone
      } else {
        return PERFORMANCE_ENDURANCE.wallpaperPad
      }
    },
  },
  mounted() {
    initExposureTrack('.performance-and-endurance [data-position]')()
    this.initVideoObserver();
  },
};
</script>

<style lang="scss" scoped>
.performance-and-endurance {
  position: relative;
  background: rgba(0, 0, 0, 1);
}

.performance-and-endurance {
  .efficiency-engine{
    height: calc(900 + 120) * $px1920vw + vw;
    padding-top: 120 * $px1920vw + vw;
    background: rgba(0, 0, 0, 1);
    .efficiency-engine-container{
      height: 900 * $px1920vw + vw;
      position: relative;

      .efficiency-engine-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        z-index: 0;
      }

      .efficiency-engine-content{
        position: absolute;
        top: 24 * $px1920vw + vw;
        left: 408 * $px1920vw + vw;
        display: flex;
        align-items: start;
        flex-direction: column;
        letter-spacing: normal;
        z-index: 1;

        .efficiency-engine-content-title{
          font-size: 28 * $px1920vw + vw;
          line-height: 33.6 * $px1920vw + vw;
          color: #2785FF;
        }
        .efficiency-engine-content-subtitle{
          font-size: 64 * $px1920vw + vw;
          line-height: 76.8 * $px1920vw + vw;
          color: #FFFFFF;
          margin-top: 12 * $px1920vw + vw;
          text-align: start;
        }
        .efficiency-engine-content-description{
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 24 * $px1920vw + vw;
          display: flex;
          flex-direction: column;
          align-items: start;
        }
      }
    }
    .efficiency-engine-data-container{
      width: 901 * $px1920vw + vw;
      height: 183 * $px1920vw + vw;
      top: 597 * $px1920vw + vw;
      left: 481 * $px1920vw + vw;
      position: absolute;
      border-radius: 30 * $px1920vw + vw;
      background: linear-gradient(180deg, rgba(34, 32, 29, 0.95) 0%, rgba(26, 26, 26, 0.95) 100%);
      padding: 35 * $px1920vw + vw  0 39 * $px1920vw + vw  0;
      display: flex;
      justify-content: space-evenly;
      z-index: 1;

      .efficiency-engine-data-item{
        letter-spacing: normal;
        color: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: start;

        .efficiency-engine-data-item-description{
          font-size: 22 * $px1920vw + vw;
          line-height: 28.8 * $px1920vw + vw;
        }
  
        .efficiency-engine-data-item-number{
          font-size: 64 * $px1920vw + vw;
          line-height: 75.6 * $px1920vw + vw;
          margin-top: 4 * $px1920vw + vw;
        }
      }
    }
  }
  .endurance-technology{
    height: 1451 * $px1920vw + vw;
    background: rgba(30, 30, 30, 1);

    .card-container{
      top: 120 * $px1920vw + vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
    }
    // 微电精灵
    .micro-power-elf{
      width: 1200 * $px1920vw + vw;
      height: 550 * $px1920vw + vw;
      border-radius: 24 * $px1920vw + vw;
      background: rgba(0, 0, 0, 1);
      position: relative;

      .micro-power-elf-content-container{
        top: 48 * $px1920vw + vw;
        left: 48 * $px1920vw + vw;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: start;
        letter-spacing: normal;

        .micro-power-elf-content-title{
          font-size: 28 * $px1920vw + vw;
          line-height: 33.6 * $px1920vw + vw;
          color: #2785FF;
        }
        .micro-power-elf-content-subtitle{
          font-size: 40 * $px1920vw + vw;
          line-height: 48 * $px1920vw + vw;
          color: #FFFFFF;
          margin-top: 12 * $px1920vw + vw;
        }
        .micro-power-elf-content-description{
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 36 * $px1920vw + vw;
          display: flex;
          flex-direction: column;
          align-items: start;
        }
      }
      .micro-power-elf-phone-container{
        top: 166 * $px1920vw + vw;
        right: 1 * $px1920vw + vw;
        width: 737 * $px1920vw + vw;
        height: 300 * $px1920vw + vw;
        position: absolute;
        .micro-power-elf-phone-model{
          width: 624.05 * $px1920vw + vw;
          height: auto;
          z-index: 10;
          position: absolute;
          top: 0;
          left: 0;
        }
        .micro-power-elf-phone-wallpaper{
          width: 605.04 * $px1920vw + vw;
          height: auto;
          position: absolute;
          bottom: 9.63 * $px1920vw + vw;
          left: 9.62 * $px1920vw + vw;
          border-radius: 27.5 * $px1920vw + vw;
          z-index: 9;
          overflow: hidden;
        }
        .micro-power-elf-phone-charger{
          width: 139 * $px1920vw + vw;
          height: auto;
          position: absolute;
          bottom: 129 * $px1920vw + vw;
          right: 0;
          z-index: 8;
        }
      }
    }

    .sm-card-container{
      margin-top: 24 * $px1920vw + vw;
      display: flex;
      justify-content: space-between;
      gap: 24 * $px1920vw + vw;
      position: relative;

      .sm-card{
        width: 588 * $px1920vw + vw;
        height: 600 * $px1920vw + vw;
        border-radius: 24 * $px1920vw + vw;
        background: rgba(0, 0, 0, 1);
        position: relative;
      }
    }

    // 直驱供电
    .direct-drive-power-supply{
      
      .direct-drive-power-supply-container{
        display: flex;
        flex-direction: column;
        align-items: start;
        letter-spacing: normal;
        text-align: start;
        top: 48 * $px1920vw + vw;
        left: 48 * $px1920vw + vw;
        position: absolute;

        .direct-drive-power-supply-title{
          font-size: 24 * $px1920vw + vw;
          line-height: 28.8 * $px1920vw + vw;
          color: #2785FF;
        }
        .direct-drive-power-supply-subtitle{
          font-size: 32 * $px1920vw + vw;
          line-height: 38.4 * $px1920vw + vw;
          color: #FFFFFF;
          margin-top: 8 * $px1920vw + vw;
        }
        .direct-drive-power-supply-description{
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 16 * $px1920vw + vw;
          max-width: 486 * $px1920vw + vw;
        }
      }
      .direct-drive-power-supply-phone-container{
        bottom: 14 * $px1920vw + vw;
        left: 28 * $px1920vw + vw;
        width: 560 * $px1920vw + vw;
        height: 303 * $px1920vw + vw;
        position: absolute;
        .direct-drive-power-supply-phone{
          width: 560 * $px1920vw + vw;
          height: 303 * $px1920vw + vw;
        }
      }
    }
    // 轻量化系统
    .lightweight-system{
      .lightweight-system-container{
        display: flex;
        flex-direction: column;
        align-items: start;
        letter-spacing: normal;
        width: 360 * $px1920vw + vw;
        text-align: start;
        top: 48 * $px1920vw + vw;
        left: 48 * $px1920vw + vw;
        position: absolute;

        .lightweight-system-title{
          font-size: 24 * $px1920vw + vw;
          line-height: 28.8 * $px1920vw + vw;
          color: #2785FF;
        }
        .lightweight-system-subtitle{
          font-size: 32 * $px1920vw + vw;
          line-height: 38.4 * $px1920vw + vw;
          color: #FFFFFF;
          margin-top: 8 * $px1920vw + vw;
        }
        .lightweight-system-description{
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(255, 255, 255, 0.8);
          margin-top: 16 * $px1920vw + vw;
        }
      }
      .lightweight-system-image-container{
        top: 160 * $px1920vw + vw;
        right: 49 * $px1920vw + vw;
        position: absolute;
        width: 490 * $px1920vw + vw;
        height: 440 * $px1920vw + vw;
        mix-blend-mode: screen;
        opacity: 0.9;
        .lightweight-system-image{
          width: 100%;
          height: 100%;
        }
        .lightweight-system-image-text{
          top: 161 * $px1920vw + vw;
          left: 157 * $px1920vw + vw;
          width: 176 * $px1920vw + vw;
          position: absolute;
          letter-spacing: normal;
          font-size: 0;
          .lightweight-system-image-number{
            font-size: 22 * $px1920vw + vw;
            line-height: 28.8 * $px1920vw + vw;
            color: rgba(255, 255, 255, 0.8);
          }
          .lightweight-system-image-unit{
            font-size: 64 * $px1920vw + vw;
            line-height: 75.6 * $px1920vw + vw;
            text-align: center;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}

// pad端
.isPad {
  .performance-and-endurance{
    .efficiency-engine{
      height: auto;
      padding-top: 0;
      .efficiency-engine-container{
        height: 460 * $px676vw + vw;
        display: flex;
        flex-direction: column;
        align-items: center;
  
        .efficiency-engine-content{
          position: absolute;
          top: 36 * $px676vw + vw;
          left: 76 * $px676vw + vw;
          text-align: start;
          z-index: 1;
  
          .efficiency-engine-content-title{
            font-size: 12 * $px676vw + vw;
            line-height: normal;
          }
          .efficiency-engine-content-subtitle{
            font-size: 25 * $px676vw + vw;
            line-height: normal;
            margin-top: 6 * $px676vw + vw;
          }
          .efficiency-engine-content-description{
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            margin-top: 12 * $px676vw + vw;
          }
        }
      }
      .efficiency-engine-data-container{
        width: 400 * $px676vw + vw;
        height: 81.23 * $px676vw + vw;
        top: 342.75 * $px676vw + vw;
        left: auto;
        border-radius: 13.2 * $px676vw + vw;
        padding: 15.08 * $px676vw + vw  0 15.38 * $px676vw + vw  0;
        z-index: 1;

        .efficiency-engine-data-item{
  
          .efficiency-engine-data-item-description{
            font-size: 10.56 * $px676vw + vw;
            line-height: 12.67 * $px676vw + vw;
          }
    
          .efficiency-engine-data-item-number{
            font-size: 28.16 * $px676vw + vw;
            line-height: 33.27 * $px676vw + vw;
            margin-top: 3.52 * $px676vw + vw;
          }
        }
      }
    }
    .endurance-technology{
      height: 752 * $px676vw + vw;

      .card-container{
        top: 36 * $px676vw + vw;
      }
      // 微电精灵
      .micro-power-elf{
        width: 596 * $px676vw + vw;
        height: 300 * $px676vw + vw;
        border-radius: 16 * $px676vw + vw;

        .micro-power-elf-content-container{
          top: 36 * $px676vw + vw;
          left: 36 * $px676vw + vw;
          text-align: start;

          .micro-power-elf-content-title{
            font-size: 12 * $px676vw + vw;
            line-height: normal;
          }
          .micro-power-elf-content-subtitle{
            font-size: 25 * $px676vw + vw;
            line-height: normal;
            margin-top: 6 * $px676vw + vw;
          }
          .micro-power-elf-content-description{
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            margin-top: 12 * $px676vw + vw;
            display: block;
          }
        }
        .micro-power-elf-phone-container{
          top: 125.26 * $px676vw + vw;
          right: 0;
          width: calc(271.96 + 48.04) * $px676vw + vw;
          height: 130.74 * $px676vw + vw;
          .micro-power-elf-phone-model{
            width: 271.96 * $px676vw + vw;
            height: auto;
          }
          .micro-power-elf-phone-wallpaper{
            width: 263.68 * $px676vw + vw;
            bottom: 4.09 * $px676vw + vw;
            left: 4.19 * $px676vw + vw;
            border-radius: 11.99 * $px676vw + vw;
          }
          .micro-power-elf-phone-charger{
            width: 59.58 * $px676vw + vw;
            bottom: 56.63 * $px676vw + vw;
          }
        }
      }

      .sm-card-container{
        margin-top: 20 * $px676vw + vw;
        justify-content: space-between;
        gap: 20 * $px676vw + vw;

        .sm-card{
          width: 288 * $px676vw + vw;
          max-height: 360 * $px676vw + vw;
          border-radius: 16 * $px676vw + vw;
        }
      }

      // 直驱供电
      .direct-drive-power-supply{
        height: 360 * $px676vw + vw !important;
        .direct-drive-power-supply-container{
          top: 36 * $px676vw + vw;
          left: 22 * $px676vw + vw;

          .direct-drive-power-supply-title{
            font-size: 12 * $px676vw + vw;
            line-height: normal;
          }
          .direct-drive-power-supply-subtitle{
            font-size: 20 * $px676vw + vw;
            line-height: normal;
            margin-top: 6 * $px676vw + vw;
          }
          .direct-drive-power-supply-description{
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            margin-top: 12 * $px676vw + vw;
            max-width: 244 * $px676vw + vw;
          }
        }
        .direct-drive-power-supply-phone-container{
          bottom: 24 * $px676vw + vw;
          left: 15 * $px676vw + vw;
          width: 273 * $px676vw + vw;
          height: 142 * $px676vw + vw;
          .direct-drive-power-supply-phone{
            width: 273 * $px676vw + vw;
            height: 142 * $px676vw + vw;
          }
        }
      }
      // 轻量化系统
      .lightweight-system{
        height: 360 * $px676vw + vw !important;
        .lightweight-system-container{
          width: 244 * $px676vw + vw;
          top: 36 * $px676vw + vw;
          left: 22 * $px676vw + vw;

          .lightweight-system-title{
            font-size: 12 * $px676vw + vw;
            line-height: normal;
          }
          .lightweight-system-subtitle{
            font-size: 20 * $px676vw + vw;
            line-height: normal;
            margin-top: 6 * $px676vw + vw;
          }
          .lightweight-system-description{
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            margin-top: 12 * $px676vw + vw;
          }
        }
        .lightweight-system-image-container{
          top: 124.22 * $px676vw + vw;
          right: 36.23 * $px676vw + vw;
          width: 215.05 * $px676vw + vw;
          height: 215.05 * $px676vw + vw;
          .lightweight-system-image-text{
            top: 77.78 * $px676vw + vw;
            left: 63.27 * $px676vw + vw;
            width: 96 * $px676vw + vw;
            
            .lightweight-system-image-number{
              font-size: 12 * $px676vw + vw;
              line-height: 14.4 * $px676vw + vw;
            }
            .lightweight-system-image-unit{
              font-size: 35.37 * $px676vw + vw;
              line-height: 37.8 * $px676vw + vw;
            }
          }
        }
      }
    }
  }
}

.isMobile {
  .performance-and-endurance{
    .efficiency-engine{
      height: auto;
      padding-top: 0;
      .efficiency-engine-container{
        height: 460 * $px360vw + vw;
        display: flex;
        flex-direction: column;
        align-items: center;
  
        .efficiency-engine-content{
          position: relative;
          top: 36 * $px360vw + vw;
          left: auto;
          text-align: start;
          z-index: 1;
  
          .efficiency-engine-content-title{
            font-size: 12 * $px360vw + vw;
            line-height: normal;
          }
          .efficiency-engine-content-subtitle{
            font-size: 25 * $px360vw + vw;
            line-height: normal;
            margin-top: 6 * $px360vw + vw;
          }
          .efficiency-engine-content-description{
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            margin-top: 12 * $px360vw + vw;
          }
        }
      }
      .efficiency-engine-data-container{
        width: 320 * $px360vw + vw;
        height: 64.94 * $px360vw + vw;
        top: 360 * $px360vw + vw;
        left: auto;
        border-radius: 10.56 * $px360vw + vw;
        padding: 12.26 * $px360vw + vw  0 11.9 * $px360vw + vw  0;
        justify-content: space-evenly;
        z-index: 1;

        .efficiency-engine-data-item{
  
          .efficiency-engine-data-item-description{
            font-size: 8.45 * $px360vw + vw;
            line-height: 10.14 * $px360vw + vw;
          }
    
          .efficiency-engine-data-item-number{
            font-size: 22.53 * $px360vw + vw;
            line-height: 26.61 * $px360vw + vw;
            margin-top: 2.82 * $px360vw + vw;
          }
        }
      }
    }
    .endurance-technology{
      height: 1192 * $px360vw + vw;

      .card-container{
        top: 36 * $px360vw + vw;
      }
      // 微电精灵
      .micro-power-elf{
        width: 320 * $px360vw + vw;
        height: 360 * $px360vw + vw;
        border-radius: 10 * $px360vw + vw;

        .micro-power-elf-content-container{
          top: 28 * $px360vw + vw;
          left: 22 * $px360vw + vw;
          // align-items: center;
          text-align: start;

          .micro-power-elf-content-title{
            font-size: 12 * $px360vw + vw;
            line-height: normal;
          }
          .micro-power-elf-content-subtitle{
            font-size: 25 * $px360vw + vw;
            line-height: normal;
            margin-top: 6 * $px360vw + vw;
          }
          .micro-power-elf-content-description{
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            margin-top: 12 * $px360vw + vw;
            display: block;
          }
        }
        .micro-power-elf-phone-container{
          top: 173.9 * $px360vw + vw;
          // right: -31.68 * $px360vw + vw;
          right: 0;
          width: calc(279.16 + 17.84) * $px360vw + vw;
          height: 134.2 * $px360vw + vw;
          overflow: hidden;
          .micro-power-elf-phone-model{
            width: 279.16 * $px360vw + vw;
            height: auto;
          }
          .micro-power-elf-phone-wallpaper{
            width: 270.66 * $px360vw + vw;
            bottom: 4.2 * $px360vw + vw;
            left: 4.31 * $px360vw + vw;
            border-radius: 12.3 * $px360vw + vw;
          }
          .micro-power-elf-phone-charger{
            width: 61.16 * $px360vw + vw;
            bottom: 57.2 * $px360vw + vw;
            right: -31.6 * $px360vw + vw;
          }
        }
      }

      .sm-card-container{
        margin-top: 20 * $px360vw + vw;
        flex-direction: column;
        justify-content: space-between;
        gap: 20 * $px360vw + vw;

        .sm-card{
          width: 320 * $px360vw + vw;
          max-height: 360 * $px360vw + vw;
          border-radius: 10 * $px360vw + vw;
        }
      }

      // 直驱供电
      .direct-drive-power-supply{
        height: 360 * $px360vw + vw !important;
        .direct-drive-power-supply-container{
          top: 36 * $px360vw + vw;
          left: 22 * $px360vw + vw;

          .direct-drive-power-supply-title{
            font-size: 12 * $px360vw + vw;
            line-height: normal;
          }
          .direct-drive-power-supply-subtitle{
            font-size: 20 * $px360vw + vw;
            line-height: normal;
            margin-top: 6 * $px360vw + vw;
          }
          .direct-drive-power-supply-description{
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            margin-top: 12 * $px360vw + vw;
            max-width: 277 * $px360vw + vw;
          }
        }
        .direct-drive-power-supply-phone-container{
          bottom: 9.63 * $px360vw + vw;
          left: 15 * $px360vw + vw;
          width: 304.76 * $px360vw + vw;
          height: 158.37 * $px360vw + vw;
          .direct-drive-power-supply-phone{
            width: 304.76 * $px360vw + vw;
            height: 158.37 * $px360vw + vw;
          }
        }
      }
      // 轻量化系统
      .lightweight-system{
        height: 360 * $px360vw + vw !important;
        .lightweight-system-container{
          width: 277 * $px360vw + vw;
          top: 28 * $px360vw + vw;
          left: 22 * $px360vw + vw;

          .lightweight-system-title{
            font-size: 12 * $px360vw + vw;
            line-height: normal;
          }
          .lightweight-system-subtitle{
            font-size: 20 * $px360vw + vw;
            line-height: normal;
            margin-top: 6 * $px360vw + vw;
          }
          .lightweight-system-description{
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            margin-top: 12 * $px360vw + vw;
          }
        }
        .lightweight-system-image-container{
          top: 111 * $px360vw + vw;
          right: 42.1 * $px360vw + vw;
          width: 234.9 * $px360vw + vw;
          height: 234.9 * $px360vw + vw;
          .lightweight-system-image-text{
            top: 82.65 * $px360vw + vw;
            left: 65.25 * $px360vw + vw;
            width: 114.55 * $px360vw + vw;
            .lightweight-system-image-number{
              font-size: 11.6 * $px360vw + vw;
              line-height: 14.5 * $px360vw + vw;
            }
            .lightweight-system-image-unit{
              font-size: 46.08 * $px360vw + vw;
              line-height: normal;
            }
          }
        }
      }
    }
  }
}
</style>